<template>
    <div>
        500
    </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "error-500",
  components: {},
  setup() {

  },
});
</script>
